/**
 * @file text-style.ts
 * @description Фон под текстом элемента секции — для контраста поля цвета
 * текста (SB8; SB120 этапы 1 и 3а, uiux-sb120-stage3 §2.1).
 *
 * Фон под элементом — свой фон колонки (`column.bg`), иначе фон секции
 * (`look.bg`). С подложкой (`look.card.on`) фон секции рисуется на самой
 * подложке (витрина `SectionV2`), а при прозрачном фоне подложка — роль
 * «Карточки». Роль или свой цвет — контраст считается точно; фото —
 * «проверьте на канве».
 *
 * С секции v4 цвет и шрифт элемента — `typo` по частям (element-typo.ts);
 * прежние роли v3 (`colorRole`, `fontRole`) и замок цвета кнопки сняты.
 */

import type { SectionBg, SectionPayload, SiteColors } from "@chaiberi/shared";

/** Фон секции под текстом: на подложке с прозрачным фоном — «Карточки», иначе фон секции. */
export function sectionSurfaceBg(look: SectionPayload["look"]): SectionBg {
  return look.card.on && look.bg.kind === "transparent" ? { kind: "role", role: "cardBg" } : look.bg;
}

/** Фон под элементом колонки: свой фон колонки, иначе фон секции (с учётом подложки). */
export function elementBg(payload: SectionPayload, col: number): SectionBg {
  return payload.columns.items[col]?.bg ?? sectionSurfaceBg(payload.look);
}

/**
 * Фон секции для поля цвета текста (`ColorField mode="text"`, `elementBg`):
 * `#hex` роли или своего цвета, фон страницы у прозрачной, `"photo"` у
 * фото — контраст по фото не считается (SB120 этап 1, uiux-sb120-stage1 §2.3).
 */
export function sectionBgSample(bg: SectionBg, colors: SiteColors): string {
  if (bg.kind === "media") return "photo";
  if (bg.kind === "custom") return bg.color;
  return colors[bg.kind === "role" ? bg.role : "pageBg"];
}
